import React from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import Async from 'react-code-splitting'
import Amplify from 'aws-amplify'
import configDev from '@wellbeingxltd/fe-lib/api/user/aws-exports-dev-web'
import configDemo from '@wellbeingxltd/fe-lib/api/user/aws-exports-demo'
import configStg from '@wellbeingxltd/fe-lib/api/user/aws-exports-stg'
import configPrd from '@wellbeingxltd/fe-lib/api/user/aws-exports-prd'
import { __ENV__ } from 'awsApi'
import mixpanel from 'mixpanel-browser'
import { MIXPANEL_PROJECT_TOKEN } from 'assets/database/constants'
import '@wellbeingxltd/fe-lib/styles/web/index.scss'
import { ROUTES } from 'helpers/routes'
import { useProfile } from 'hooks/useProfile'
import '../sass/index.scss'
import PopupForm from 'components/common/PopupForm'

/* eslint-disable default-case */
switch (__ENV__) {
    case 'DEV':
        Amplify.configure(configDev)
        break
    case 'DEMO':
        Amplify.configure(configDemo)
        break
    case 'STG':
        Amplify.configure(configStg)
        break
    case 'PRD':
        Amplify.configure(configPrd)
        break
}

mixpanel.init(MIXPANEL_PROJECT_TOKEN, { debug: __ENV__ === 'PRD' ? false : true })

const Landing = props => <Async load={import('./Landing')} componentProps={props} />
const Header = props => <Async load={import('./Header')} componentProps={props} />
const Footer = props => <Async load={import('./Footer.jsx')} componentProps={props} />
const FooterC = props => <Async load={import('../components/common/Footer/Footer.jsx')} componentProps={props} />
const Announcer = props => <Async load={import('./Announcer')} componentProps={props} />
const FeedbackWidget = props => <Async load={import('./FeedbackWidget')} componentProps={props} />
const PopupLocale = props => <Async load={import('./PopupLocale')} componentProps={props} />
const Focus = props => <Async load={import('./Focus')} componentProps={props} />

const LoginEmailSignUp = props => <Async load={import('./LoginEmailSignUp')} componentProps={props} />
const LoginEmailSignUpConfirm = props => <Async load={import('./LoginEmailSignUpConfirm')} componentProps={props} />
const LoginEmailLogin = props => <Async load={import('./LoginEmailLogin')} componentProps={props} />
const LoginEmailLoginConfirm = props => <Async load={import('./LoginEmailLoginConfirm')} componentProps={props} /> // First login
const LoginEmailLoginSms = props => <Async load={import('./LoginEmailLoginSms')} componentProps={props} /> // Subsequent logins
const LoginForgot = props => <Async load={import('./LoginEmailForgot')} componentProps={props} />
const LoginForgotConfirm = props => <Async load={import('./LoginEmailForgotConfirm')} componentProps={props} />
const LoginInvitationCode = props => <Async load={import('./LoginInvitationCode')} componentProps={props} />
const LoginResetMobile = props => <Async load={import('./LoginEmailResetPhone')} componentProps={props} />
const LoginSSOCallback = props => <Async load={import('./LoginSSOCallback')} componentProps={props} />

const AccessibilityStatement = props => <Async load={import('./AccessibilityStatement.jsx')} componentProps={props} />
const Resource = props => <Async load={import('./Resource.jsx')} componentProps={props} />
const Onboarding = props => <Async load={import('./Onboarding')} componentProps={props} />
const AssessmentDemo = props => <Async load={import('./Assessment_demo.jsx')} componentProps={props} />
const Discover = props => <Async load={import('./Discover.jsx')} componentProps={props} />
const Favourites = props => <Async load={import('./Favourites.jsx')} componentProps={props} />
const Home = props => <Async load={import('./Home')} componentProps={props} />
const InHouseBenefits = props => <Async load={import('./InHouseBenefits')} componentProps={props} />
const ManageMyData = props => <Async load={import('./ManageMyData.jsx')} componentProps={props} />
const OrderHelp = props => <Async load={import('./OrderHelp.jsx')} componentProps={props} />
const Orders = props => <Async load={import('./Orders.jsx')} componentProps={props} />
const Privacy = props => <Async load={import('./Privacy.jsx')} componentProps={props} />
const Profile = props => <Async load={import('./Profile')} componentProps={props} />
// const Search = props => <Async load={import('./Search.jsx')} componentProps={props} />
const Sitemap = props => <Async load={import('./Sitemap.jsx')} componentProps={props} />
const TermsAndConditions = props => <Async load={import('./TermsAndConditions.jsx')} componentProps={props} />
const WellbeingGoals = props => <Async load={import('./WellbeingGoals/index.jsx')} componentProps={props} />
const WellbeingHub = props => <Async load={import('./WellbeingHub/index.jsx')} componentProps={props} />
const Appreciation = props => <Async load={import('./Appreciation/index.jsx')} componentProps={props} />
const Events = props => <Async load={import('./Events/index.jsx')} componentProps={props} />
const Event = props => <Async load={import('./Events/Event/index.jsx')} componentProps={props} />

const App = () => {
    return (
        <BrowserRouter>
            <>
                <Route path="/" component={Focus} />
                <Route
                    path="/*"
                    render={props => (
                        <Header
                            hide={
                                props.location.pathname === '/' ||
                                props.location.pathname === '/getInvitationCode' ||
                                props.location.pathname === '/callback'
                            }
                        />
                    )}
                />
                <div style={{ minHeight: '100vh' }}>
                    <Switch>
                        {/* Unauthenticated routes */}
                        {/* If a new route is added here, don't forget to update unAuthenticatedRoutes in Header container */}
                        <Route exact path="/" component={Landing} />
                        <Route exact path="/signup" component={LoginEmailSignUp} />
                        <Route exact path="/signupConfirm" component={LoginEmailSignUpConfirm} />
                        <Route exact path="/login" component={LoginEmailLogin} />
                        <Route exact path="/loginConfirm" component={LoginEmailLoginConfirm} /> {/* First login */}
                        <Route exact path="/loginSms" component={LoginEmailLoginSms} /> {/* Subsequent logins */}
                        <Route exact path="/loginForgot" component={LoginForgot} />
                        <Route exact path="/loginForgotConfirm" component={LoginForgotConfirm} />
                        <Route exact path="/loginResetMobile" component={LoginResetMobile} />
                        <Route exact path="/getInvitationCode" component={LoginInvitationCode} />
                        <Route exact path="/callback" component={LoginSSOCallback} />
                        <Route exact path="/privacy" component={Privacy} />
                        <Route exact path="/tc" component={TermsAndConditions} />
                        <Route exact path="/assessmentDemo" component={AssessmentDemo} />
                        {/* Authenticated routes */}
                        <Route exact path="/accessibilityStatement" component={AccessibilityStatement} />
                        <Route exact path="/onboarding" component={Onboarding} />
                        <Route exact path={ROUTES.Search} component={Discover} />
                        <Route exact path="/favourites" component={Favourites} />
                        <Route exact path="/home" component={Home} />
                        <Route exact path="/recognition" component={Appreciation} />
                        <Route exact path="/inHouseBenefits" component={InHouseBenefits} />
                        <Route exact path="/manageMyData" component={ManageMyData} />
                        <Route exact path="/orderHelp" component={OrderHelp} />
                        <Route exact path={ROUTES.Orders} component={Orders} />
                        <Route exact path="/profile" component={Profile} />
                        <Route path="/resource" component={Resource} />
                        {/* <Route exact path="/search" component={Search} /> */}
                        <Route exact path="/sitemap" component={Sitemap} />
                        <Route exact path="/events" component={Events} />
                        <Route exact path="/event/:idEvent" component={Event} />
                        <Route exact path={'/wellbeingHub'} component={WellbeingHub} />
                        <Route exact path={ROUTES['Wellbeing Goals']} component={WellbeingGoals} />
                    </Switch>
                </div>
                <FooterC />

                <Route exact path="/privacy" component={Footer} />
                <Route exact path="/tc" component={Footer} />
                <Route exact path="/home" component={FeedbackWidget} />
                <Route path="/" component={Announcer} />
                <Route path="/" component={PopupLocale} />
                <Route path="/" component={PopupForm} />
            </>
        </BrowserRouter>
    )
}

export default App
